import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { businessApiService } from "../services/businessApiService";
import { fromBusinessDto, type Business } from "../types/businessTypes";

const staleTime = 30 * 60 * 1000;

export const businessKeys = {
  all: ["business"] as const,
  list: (userId?: string) => [...businessKeys.all, "list", userId] as const,
};

export const useBusinesses = () => {
  const { user, loading, getAuthGeneration } = useAuth();
  return useQuery<Business[], Error>({
    queryKey: businessKeys.list(user?.id),
    queryFn: async ({ signal }) => {
      const generation = getAuthGeneration();
      const dtos = await businessApiService.getAll(signal);
      signal.throwIfAborted();
      if (generation !== getAuthGeneration()) throw new Error("Your account changed.");
      return dtos.map(fromBusinessDto);
    },
    staleTime,
    enabled: !!user && !loading,
  });
};
